module.exports = __webpack_public_path__ + "media/images/default/lp_title_slash-6d7b23b33d76f032dbb5451df9c18459.svg";